// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","icon":"styles_icon__1axQd"};